import { Table, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const TextPrimary = styled(Text)`
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;

    color: #242424;
`;
export const TableStyle = styled(Table)`
    [role="columnheader"] > .ui-table__cell__content {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 31px;
        color: #616161;
    }
    [role="cell"] > .ui-table__cell__content {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 48px;
        color: #252525;
    }
    [role="row"] > :last-child {
        justify-content: flex-end;
        align-items: flex-end;
        flex: 0.1;
        button {
            justify-content: flex-end;
        }
    }
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.07);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
`;
